export const MY_POSTS_LOADING_MORE = 'my-posts.loading-more';
